import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-shell">
        <span>yellowHatpro&apos;s coding journey.</span>
      </div>
    </footer>
  );
}

export default Footer;
